var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "invoices"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29903",
    "data-name": "Rectangle 29903",
    width: 16,
    height: 16,
    transform: "translate(26 537)",
    fill: "#a5a2b4",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_825",
    "data-name": "Mask Group 825",
    transform: "translate(-26 -537)",
    clipPath: "url(#invoices)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-05-08T134543.269",
    "data-name": "svgexport-6 - 2022-05-08T134543.269",
    transform: "translate(26 537.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27383",
    "data-name": "Path 27383",
    d: "M12.26,2.284h.021l.036,0a.579.579,0,0,1,.568.578.259.259,0,0,0,.518,0,1.1,1.1,0,0,0-.863-1.072V1.539a.259.259,0,1,0-.518,0V1.8a1.1,1.1,0,0,0,.284,2.158.579.579,0,1,1-.579.579.259.259,0,1,0-.518,0,1.1,1.1,0,0,0,.814,1.06v.284a.259.259,0,1,0,.518,0V5.609a1.1,1.1,0,0,0-.235-2.169.579.579,0,0,1-.045-1.156Zm0,0",
    fill: "#a5a2b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27384",
    "data-name": "Path 27384",
    d: "M12.32.013A3.719,3.719,0,0,0,8.854,2.447H2.42a.271.271,0,0,0-.259.271L2.1,11.811H.266A.255.255,0,0,0,0,12.058v1.154A2.036,2.036,0,0,0,1.944,15.24v.006h8v-.008c.065,0,.092.008.133.008h.006a2.036,2.036,0,0,0,2.033-2.036V7.375c.065,0,.133.005.2.005a3.684,3.684,0,0,0,0-7.368ZM2.043,14.727h0A1.525,1.525,0,0,1,.518,13.209v-.88H8.036v.876a2.034,2.034,0,0,0,.6,1.441c.027.027.061.048.089.081ZM11.6,13.209a1.518,1.518,0,0,1-1.515,1.518h0a1.529,1.529,0,0,1-1.526-1.521V12.058a.239.239,0,0,0-.247-.247H2.618l.059-8.846H8.71a3.9,3.9,0,0,0-.071.72,3.655,3.655,0,0,0,.313,1.483H6.5a.259.259,0,0,0,0,.518h2.73A3.658,3.658,0,0,0,11.6,7.31Zm.72-6.347A3.162,3.162,0,1,1,15.482,3.7,3.162,3.162,0,0,1,12.32,6.862Zm0,0",
    fill: "#a5a2b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27385",
    "data-name": "Path 27385",
    d: "M4.84,6.894a.8.8,0,1,0,.83.8A.818.818,0,0,0,4.84,6.894Zm0,1.088A.286.286,0,1,1,5.151,7.7.3.3,0,0,1,4.84,7.982Zm0,0",
    fill: "#a5a2b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27386",
    "data-name": "Path 27386",
    d: "M6.245,7.7a.259.259,0,0,0,.259.259H9.96a.259.259,0,0,0,0-.518H6.5A.259.259,0,0,0,6.245,7.7Zm0,0",
    fill: "#a5a2b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27387",
    "data-name": "Path 27387",
    d: "M4.84,4.64a.8.8,0,1,0,.83.8A.818.818,0,0,0,4.84,4.64Zm0,1.088a.286.286,0,1,1,.311-.285.3.3,0,0,1-.311.285Zm0,0",
    fill: "#a5a2b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27388",
    "data-name": "Path 27388",
    d: "M4.84,9.147a.8.8,0,1,0,.83.8A.818.818,0,0,0,4.84,9.147Zm0,1.088a.286.286,0,1,1,.311-.285A.3.3,0,0,1,4.84,10.235Zm0,0",
    fill: "#a5a2b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27389",
    "data-name": "Path 27389",
    d: "M9.96,9.7H6.5a.259.259,0,0,0,0,.518H9.96a.259.259,0,0,0,0-.518Zm0,0",
    fill: "#a5a2b4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.095008a0bd78c15578ff0a89f8a8a993.svg";
export { ForwardRef as ReactComponent };